export default __webpack_public_path__ + "static/shutupandtakemymoney-0bcbf2eff4bcca1660c776690d52c5c2.png";